import BaseApi, { API_BASE_URL, ApiResponse } from './base';

export interface FileAttachment {
  id: string;
  name: string;
  url: string;
  type: string;
}

export interface ChatMessageRequest {
  message: string;
  sessionId?: string;
  focusedStepId?: string;
  fileIds?: string[];
}

export interface ChatMessageResponse {
  content: string;
  guideUpdates?: Array<{
    type: 'guide' | 'step' | 'metadata';
    changes: Record<string, any>;
    stepId?: string;
  }>;
  isComplete: boolean;
  error?: boolean;
}

export interface ChatSession {
  sessionId: string;
  systemContext?: string;
  createdAt: string;
}

export interface ChatHistoryMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  fileAttachments?: FileAttachment[];
  focusedStepId?: string;
  guideUpdates?: {
    type: 'guide' | 'step' | 'metadata';
    changes: Record<string, any>;
  };
  createdAt: string;
}

export interface ChatSessionHistory {
  sessionId: string;
  messages: ChatHistoryMessage[];
}

class GuideAIChatApi extends BaseApi {
  constructor(baseURL: string = API_BASE_URL) {
    super(baseURL);
  }

  async createSession(guideId: string): Promise<ApiResponse<ChatSession>> {
    return this.post<ChatSession>(`/guides/${guideId}/chat/session`, { guideId });
  }

  async *sendMessage(guideId: string, request: ChatMessageRequest): AsyncGenerator<ChatMessageResponse, void, unknown> {
    const stream = this.stream<ChatMessageResponse>(`/guides/${guideId}/chat/message`, {
      method: 'POST',
      body: request,
    });

    for await (const chunk of stream) {
      yield chunk;
    }
  }

  async getSessionHistory(guideId: string, sessionId: string): Promise<ApiResponse<ChatSessionHistory>> {
    return this.get<ChatSessionHistory>(`/guides/${guideId}/chat/session/${sessionId}`);
  }
}

export default new GuideAIChatApi();
